import { defineStore } from 'pinia'

function readStoredTheme() {
  try {
    return localStorage.getItem('color-mode') ?? 'light'
  } catch {
    return 'light'
  }
}

export const useThemeStore = defineStore('theme', {
  state: () => ({
    theme: readStoredTheme()
  }),
  getters: {
    currentTheme: (state) => state.theme
  },
  actions: {
    setTheme(theme) {
      this.theme = theme
      try {
        localStorage.setItem('color-mode', theme)
      } catch {
        // storage unavailable (e.g. private browsing) — keep in-memory theme only
      }
    }
  }
})
